module.exports = __webpack_public_path__ + "img/no-unscheduled-downtime.fe256a5c.svg";